import React from 'react';
import LineChart from '@vb/components/build/components/charts/LineChart';
import { generatePriceHistoryChartData } from '../../../../../../../../utils/charts';

export const PriceHistoryChart = ({ priceHistoryTransformed }) => {
  const data = generatePriceHistoryChartData([priceHistoryTransformed]);

  return <LineChart data={data} calculationType="incremental" />;
};
